module.exports = __webpack_public_path__ + "static/media/peer-feedback-teamword-skills.39d4d686.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/peer-feedback-teamword-skills.png
// module id = 2647
// module chunks = 0